import { connect } from "react-redux";
import { Show } from "../../../../hooks/Show";

const HandleActivationSubCategoryComponent = ({
  isActive = false,
  idSubCategory = null,
  reduxChangeStateSubCategory = () => {},
}) => {
  if (isActive) {
    return (
      <Show when="feature:wms-subcategories-handle-state">
        <button
          title="Desactivar"
          className="btn btn-danger btn-sm btn-circle mr-2"
          type="button"
          onClick={() =>
            reduxChangeStateSubCategory({ isActive: false, id: idSubCategory })
          }
        >
          <i className="fas fa-times-circle fa-xs"></i>
        </button>
      </Show>
    );
  }

  return (
    <Show when="feature:wms-subcategories-handle-state">
      <button
        title="Activar"
        className="btn btn-primary btn-sm  btn-circle mr-2"
        type="button"
        onClick={() =>
          reduxChangeStateSubCategory({ isActive: true, id: idSubCategory })
        }
      >
        <i className="fas fa-check-circle fa-xs"></i>
      </button>
    </Show>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxChangeStateSubCategory: (payload) =>
      dispatch({
        type: "CHANGE_STATE_SUB_CATEGORY_REQUEST",
        value: payload,
      }),
  };
};

export const HandleActivationSubCategory = connect(null, mapDispatchToProps)(
  HandleActivationSubCategoryComponent,
);
